import Logger from "./Logger";
import { cdnPath } from "./Utils";

class ConfigManager {
  configData: Object;
  platform: string;
  adUnitToContainerIdMap: Object = {};

  async fetchConfig(site: string, env: string, platform: string) {
    try {
      const response = await window.fetch(cdnPath(`/${site}_${env}.json`));

      this.configData = await response.json();

      this.setPlatform(platform);
      Logger.log("Got config data", this.configData);
    } catch (e) {
      Logger.error("Error loading config! Cannot proceed", e);
    }
  }

  setPlatform(platform: string) {
    this.platform = platform;
  }

  hasAdUnit(adUnit: string) {
    return adUnit in this.configData[this.platform];
  }

  getAdUnitSizes(adUnit: string) {
    return this.configData[this.platform][adUnit]?.mediaTypes.banner.sizes;
  }

  getAdUnitPath(adUnit: string) {
    return this.configData[this.platform][adUnit]?.adUnit;
  }

  getPrebidAdUnitsConfig() {
    return Object.keys(this.configData[this.platform])
      .map((k) => {
        const config = this.configData[this.platform][k];
        return {
          code: this.adUnitToContainerIdMap[k],
          bids: config.bids,
          mediaTypes: config.mediaTypes,
        };
      })
      .filter((i) => !!i.code);
  }

  addAdUnitToContainerMapping(adUnit, containerId) {
    this.adUnitToContainerIdMap[adUnit] = containerId;
  }

  getContainerIdForAdUnit(adUnit) {
    return this.adUnitToContainerIdMap[adUnit];
  }
}
export default new ConfigManager();
